/*
 * QYNDA — Scan & Win
 * ---------------------------------------------------------------------------
 * Vanilla JS, no dependencies, no build step.
 *
 * This file READS ONLY. It never writes to Shopify. Single-use is enforced by
 * Shopify at checkout (usageLimit: 1 + appliesOncePerCustomer), not here.
 *
 * Flow: login gate -> read ?t= -> Storefront lookup of the `scan_card`
 * metaobject by handle -> paint prize under the foil -> scratch -> redeem.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-qsw-root]');
  if (!root) return;

  var cfg = {};
  var cfgEl = document.querySelector('[data-qsw-config]');
  if (cfgEl) {
    try {
      cfg = JSON.parse(cfgEl.textContent) || {};
    } catch (err) {
      cfg = {};
    }
  }

  var STORAGE_PREFIX = 'qynda:scan-win:';
  var REVEAL_THRESHOLD = 0.5; // auto-reveal the rest once half the foil is gone
  var TOKEN_RE = /^[a-z0-9][a-z0-9-]{0,127}$/;
  var SUPPORT_NOTE =
    'Your prize is confirmed, but we could not load its code. Please contact us with your card and we will sort it out.';

  /*
   * The QYNDA mark, inlined as a data URI rather than loaded from the CDN.
   * A cross-origin image would taint the canvas, and a tainted canvas cannot
   * be read with getImageData — which is exactly how the scratch progress is
   * measured. Inlining keeps the canvas clean.
   */
  var MARK_SRC = 'data:image/png;base64,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';
  var markImage = null;
  var coverImage = null;
  var coverEdge = null;

  var FREE_TIERS = { free_top: 1, free_ladina: 1, free_thabya: 1 };
  var CODE_TIERS = { d15: 1, d20: 1 };

  // Fallback only. The headline is normally read out of the prize label.
  var TIER_HEADLINE = { d15: '15% OFF', d20: '20% OFF' };

  // ---------------------------------------------------------------- helpers

  function $(sel) {
    return root.querySelector(sel);
  }

  /*
   * hidden is an HTMLElement property, so assigning it to an <svg> silently
   * does nothing. Go through the attribute, which every element honours.
   */
  function setHidden(el, on) {
    if (!el) return;
    if (on) el.setAttribute('hidden', '');
    else el.removeAttribute('hidden');
  }

  function show(name) {
    var screens = root.querySelectorAll('[data-qsw-screen]');
    for (var i = 0; i < screens.length; i++) {
      screens[i].hidden = screens[i].getAttribute('data-qsw-screen') !== name;
    }
  }

  function fail(detail) {
    var el = $('[data-qsw-error-detail]');
    if (el && detail) el.textContent = detail;
    show('error');
  }

  function announce(msg) {
    var live = $('[data-qsw-live]');
    if (live) live.textContent = msg;
  }

  // localStorage throws in Safari private mode — never let that break the page.
  function storeGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (err) {
      return null;
    }
  }

  function storeSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (err) {
      /* non-fatal */
    }
  }

  function readToken() {
    var raw = '';
    try {
      raw = new URLSearchParams(window.location.search).get('t') || '';
    } catch (err) {
      var m = /[?&]t=([^&]*)/.exec(window.location.search);
      if (m) {
        try {
          raw = decodeURIComponent(m[1].replace(/\+/g, ' '));
        } catch (e2) {
          raw = m[1];
        }
      }
    }
    // Shopify normalises metaobject handles to lowercase, so the lookup must be too.
    return raw.trim().toLowerCase();
  }

  // A see-through foil would show the prize before any scratching, so a colour
  // setting the merchant cleared (or set to zero alpha) must fall back.
  function opaqueOr(value, fallback) {
    var v = (value || '').trim();
    if (!v || v === 'transparent' || v === 'none') return fallback;
    var m = /^rgba\(\s*[\d.]+\s*,\s*[\d.]+\s*,\s*[\d.]+\s*,\s*([\d.]+)\s*\)$/i.exec(v);
    if (m && parseFloat(m[1]) < 0.9) return fallback;
    return v;
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  // ------------------------------------------------------------ login gate

  if (!cfg.loggedIn) {
    // Store credit and appliesOncePerCustomer both require an authenticated
    // customer. Bounce to login and come back to this exact URL, ?t= intact.
    // The redirect is built in JS because Liquid cannot read query params.
    var loginBase = cfg.loginUrl || '/account/login';
    var returnTo = window.location.pathname + window.location.search;
    var target =
      loginBase + (loginBase.indexOf('?') === -1 ? '?' : '&') + 'return_url=' + encodeURIComponent(returnTo);

    var loginLink = $('[data-qsw-login]');
    if (loginLink) loginLink.href = target;
    show('login');

    // replace() so the back button doesn't bounce them into a login loop.
    window.location.replace(target);
    return;
  }

  // ------------------------------------------------------------ token read

  /*
   * One-QR mode: the tokens come from tags on the customer record, written by
   * assign-prizes.js. There is one tag per shirt they bought, because a card
   * went into every box — three shirts means three cards and three prizes.
   *
   * Falls back to ?t= so a per-card token still works if one is ever used.
   */
  function cleanToken(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  var fromTags = Array.isArray(cfg.assignedTokens) ? cfg.assignedTokens : [];
  var tokens = [];
  var seenToken = {};

  for (var ti = 0; ti < fromTags.length; ti++) {
    var candidate = cleanToken(fromTags[ti]);
    // A duplicated tag would otherwise hand them the same prize twice.
    if (candidate && TOKEN_RE.test(candidate) && !seenToken[candidate]) {
      seenToken[candidate] = 1;
      tokens.push(candidate);
    }
  }

  var assigned = fromTags.length > 0;

  if (!tokens.length && assigned) {
    fail('There is a problem with the prize on your account. Please contact us and we will fix it.');
    return;
  }

  if (!tokens.length) {
    var urlToken = cleanToken(readToken());
    if (urlToken && !TOKEN_RE.test(urlToken)) {
      fail('That card code does not look right. Please scan the QR code on your card again.');
      return;
    }
    if (urlToken) tokens.push(urlToken);
  }

  if (!tokens.length) {
    if (cfg.designMode) {
      fail(
        'Theme editor preview: no prize is assigned to this account. On the live page, ' +
          'a customer with a prize tag sees their scratch card here.'
      );
      return;
    }
    // Signed in, but nothing assigned yet — not an error, just no prize.
    show('noprize');
    return;
  }

  if (!cfg.storefrontToken) {
    fail('This page is not finished being set up yet. Please try again shortly.');
    return;
  }

  // -------------------------------------------------------- storefront read

  function gql(query, variables) {
    var url = (cfg.apiBase || '') + '/api/' + cfg.apiVersion + '/graphql.json';

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Shopify-Storefront-Access-Token': cfg.storefrontToken
      },
      body: JSON.stringify({ query: query, variables: variables })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('http_' + res.status);
        return res.json();
      })
      .then(function (body) {
        if (body && body.errors && body.errors.length) throw new Error('graphql');
        return (body && body.data) || {};
      });
  }

  function toFields(mo) {
    if (!mo) return null; // valid response, no such card
    var out = {};
    var fields = mo.fields || [];
    for (var i = 0; i < fields.length; i++) {
      var fld = fields[i];
      if (fld && fld.key) out[fld.key] = fld.value == null ? '' : String(fld.value);
    }
    return out;
  }

  /*
   * Every card the customer holds, in ONE request, using GraphQL aliases.
   * Someone with five shirts should not pay for five round trips on a phone.
   */
  function lookupAll(handles) {
    var type = cfg.metaobjectType || 'scan_card';
    var defs = [];
    var picks = [];
    var vars = {};

    for (var i = 0; i < handles.length; i++) {
      defs.push('$h' + i + ': MetaobjectHandleInput!');
      picks.push('c' + i + ': metaobject(handle: $h' + i + ') { fields { key value } }');
      vars['h' + i] = { type: type, handle: handles[i] };
    }

    var query = 'query(' + defs.join(', ') + ') { ' + picks.join(' ') + ' }';

    return gql(query, vars).then(function (data) {
      var out = [];
      for (var j = 0; j < handles.length; j++) out.push(toFields(data['c' + j]));
      return out;
    });
  }

  // ----------------------------------------------------- prize -> UI shape

  /*
   * The metaobject carries one human label — "20% Off", "$300 Prize", "Free
   * BREATHE 2.0 T-Shirt". The reward panel wants that as a headline plus a
   * line under it, so read the number out of the label where there is one and
   * fall back to the tier.
   */
  function upper(value) {
    return String(value == null ? '' : value).toUpperCase();
  }

  function headlineFor(tier, label) {
    var r = cfg.reward || {};

    if (tier === 'cash') {
      var money = /\$\s*([\d,]+(?:\.\d+)?)/.exec(label);
      if (money) return '$' + money[1].replace(/\.00$/, '');
      return r.cashHeadline || '$300';
    }

    if (FREE_TIERS[tier]) return upper(r.freeWord || 'Free');

    var percent = /(\d+(?:\.\d+)?)\s*%/.exec(label);
    if (percent) return percent[1] + '% OFF';

    return TIER_HEADLINE[tier] || upper(label) || 'A PRIZE';
  }

  function subFor(tier, label) {
    var r = cfg.reward || {};

    if (tier === 'cash') return upper(r.cashSub || 'Digital gift card');

    if (FREE_TIERS[tier]) {
      var names = r.names || {};
      if (names[tier]) return upper(names[tier]);
      // "Free BREATHE 2.0 T-Shirt" -> "BREATHE 2.0 T-SHIRT"
      return upper(String(label).replace(/^\s*free\s+/i, '')) || 'FREE ITEM';
    }

    return upper(r.discountSub || 'On your next order');
  }

  // Discounts get a drawn coupon, so they never depend on an image loading.
  function artFor(tier) {
    var images = (cfg.reward && cfg.reward.images) || {};

    if (tier === 'cash') {
      return images.cash ? { kind: 'giftcard', src: images.cash } : { kind: 'none', src: '' };
    }
    if (FREE_TIERS[tier]) {
      return images[tier] ? { kind: 'product', src: images[tier] } : { kind: 'none', src: '' };
    }
    return { kind: 'ticket', src: '' };
  }

  function buildPrize(data, token) {
    var tier = (data.tier || '').trim();
    var label = (data.prize_label || '').trim();
    var code = (data.reward_code || '').trim();

    var r = cfg.reward || {};
    var isGift = tier === 'cash';

    var out = {
      tier: tier,
      token: token || '',
      label: label || 'A prize',
      headline: headlineFor(tier, label),
      sub: subFor(tier, label),
      art: artFor(tier),
      code: '',
      codeLabel: isGift
        ? r.codeLabelGift || 'Your gift card code'
        : r.codeLabelDiscount || 'Your discount code',
      hint: isGift ? r.hintGift || '' : r.hintDiscount || '',
      foot: isGift ? r.footGift || '' : r.footDiscount || '',
      note: '',
      cta: null
    };

    var shopNow = cfg.shopNowUrl || '/collections/all';
    var ctaText = r.ctaText || 'Shop Now';

    if (!code) {
      // The prize is real, only its code failed to arrive. Say that plainly
      // instead of showing an empty box and instructions for using it.
      out.note = SUPPORT_NOTE;
      out.hint = '';
      out.cta = { href: shopNow, text: ctaText };
      return out;
    }

    out.code = code;

    if (isGift) {
      // A gift card, not a discount: it keeps its balance, so spending part of
      // it leaves the rest for next time. It also cannot be applied by URL the
      // way a discount code can, so the button just goes shopping.
      out.note = cfg.storeCreditMessage || '';
      out.cta = { href: shopNow, text: ctaText };
      return out;
    }

    var href = '/discount/' + encodeURIComponent(code);

    // Free-item codes are scoped to one product, so land them on it.
    if (FREE_TIERS[tier]) {
      var handles = cfg.productHandles || {};
      var handle = (handles[tier] || '').trim();
      if (handle) href += '?redirect=' + encodeURIComponent('/products/' + handle);
    }

    out.cta = { href: href, text: ctaText };
    return out;
  }

  // --------------------------------------------------------------- rendering

  // Under the foil, only the headline: the moment it appears has to read at a
  // glance. Everything actionable lives on the reward panel.
  // "Card 2 of 3" — only ever shown when there is more than one.
  function progressText(n, total) {
    var tpl = (cfg.reward && cfg.reward.progressLabel) || 'Card [n] of [total]';
    return String(tpl).replace('[n]', n).replace('[total]', total);
  }

  function renderCardTeaser(prize) {
    $('[data-qsw-label]').textContent = prize.headline;

    var sub = $('[data-qsw-card-sub]');
    if (sub) sub.textContent = prize.sub;
  }

  /*
   * Pipes mark the phrase to tint: "enter your |discount code| at checkout".
   * Assembled from text nodes, never innerHTML — the copy comes from theme
   * settings and must not be able to inject markup.
   */
  function renderHint(el, template) {
    if (!el) return;
    el.textContent = '';

    var parts = String(template || '').split('|');
    for (var i = 0; i < parts.length; i++) {
      if (!parts[i]) continue;
      if (i % 2 === 1) {
        var em = document.createElement('span');
        em.className = 'qsw-reward__em';
        em.textContent = parts[i];
        el.appendChild(em);
      } else {
        el.appendChild(document.createTextNode(parts[i]));
      }
    }
  }

  function renderReward(prize) {
    $('[data-qsw-r-headline]').textContent = prize.headline;
    $('[data-qsw-r-sub]').textContent = prize.sub;

    var kind = prize.art.kind;
    var art = $('[data-qsw-art]');
    var ticket = $('[data-qsw-art-ticket]');
    var giftWrap = $('[data-qsw-art-giftcard]');
    var product = $('[data-qsw-art-product]');

    art.className = 'qsw-reward__art qsw-reward__art--' + kind;
    setHidden(art, kind === 'none');
    setHidden(ticket, kind !== 'ticket');
    setHidden(giftWrap, kind !== 'giftcard');
    setHidden(product, kind !== 'product');

    if (kind === 'giftcard') {
      var giftImg = $('[data-qsw-art-giftcard-img]');
      giftImg.src = prize.art.src;
      giftImg.alt = prize.sub;
    } else if (kind === 'product') {
      product.src = prize.art.src;
      product.alt = prize.sub;
    }

    var codeWrap = $('[data-qsw-code-wrap]');
    if (prize.code) {
      $('[data-qsw-r-code-label]').textContent = prize.codeLabel;
      $('[data-qsw-code]').textContent = prize.code;
      setHidden(codeWrap, false);
    } else {
      setHidden(codeWrap, true);
    }

    var note = $('[data-qsw-note]');
    if (prize.note) {
      note.textContent = prize.note;
      setHidden(note, false);
    } else {
      setHidden(note, true);
    }

    var cta = $('[data-qsw-cta]');
    if (prize.cta) {
      cta.href = prize.cta.href;
      $('[data-qsw-cta-text]').textContent = prize.cta.text;
      setHidden(cta, false);
    } else {
      setHidden(cta, true);
    }

    var hintBox = $('.qsw-reward__hint');
    setHidden(hintBox, !prize.hint);
    renderHint($('[data-qsw-hint-text]'), prize.hint);

    var foot = $('[data-qsw-r-foot]');
    if (foot) foot.textContent = prize.foot;
  }

  // The prize sits under the foil from the start, so keep it out of the
  // accessibility tree and out of the tab order until it is actually revealed.
  function setPrizeExposed(exposed) {
    var prize = $('[data-qsw-prize]');
    prize.setAttribute('aria-hidden', exposed ? 'false' : 'true');

    var focusables = prize.querySelectorAll('a, button');
    for (var i = 0; i < focusables.length; i++) {
      if (exposed) focusables[i].removeAttribute('tabindex');
      else focusables[i].setAttribute('tabindex', '-1');
    }
  }

  // ------------------------------------------------------------ copy button

  function initCopy() {
    var btn = $('[data-qsw-copy]');
    var textEl = $('[data-qsw-copy-text]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var value = $('[data-qsw-code]').textContent || '';
      if (!value) return;

      var done = function (ok) {
        textEl.textContent = ok ? 'Copied' : 'Press to select';
        var labelEl = $('[data-qsw-r-code-label]');
        var what = ((labelEl && labelEl.textContent) || 'Code').trim();
        announce(ok ? what + ' copied.' : 'Could not copy automatically.');
        window.setTimeout(function () {
          textEl.textContent = 'Copy';
        }, 2000);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(value).then(
          function () {
            done(true);
          },
          function () {
            done(legacyCopy(value));
          }
        );
      } else {
        done(legacyCopy(value));
      }
    });
  }

  function legacyCopy(value) {
    var ta = document.createElement('textarea');
    ta.value = value;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();

    var ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (err) {
      ok = false;
    }
    document.body.removeChild(ta);
    return ok;
  }

  // -------------------------------------------------------------- scratch

  function initScratch(onReveal) {
    // Swapped per card by restart(), so one canvas serves all of them.
    var handler = onReveal;

    var card = $('[data-qsw-card]');
    var canvas = $('[data-qsw-canvas]');
    var revealBtn = $('[data-qsw-reveal]');
    var hint = $('[data-qsw-hint]');

    var ctx = null;
    try {
      ctx = canvas.getContext('2d', { willReadFrequently: true });
    } catch (err) {
      ctx = canvas.getContext && canvas.getContext('2d');
    }

    var revealed = false;
    var started = false;
    var drawing = false;
    var last = null;
    var lastCheck = 0;
    var paintedWidth = 0;

    // No canvas support at all — degrade to the button.
    if (!ctx) {
      canvas.hidden = true;
      wireReveal();
      return { reveal: reveal, revealNow: revealNow, restart: restart };
    }

    /*
     * Grain, drawn once into an offscreen canvas and composited.
     * putImageData ignores blend modes and globalAlpha, so the noise has to go
     * through a second canvas to sit *over* the gradient rather than replace it.
     */
    function paintGrain(w, h, amount) {
      var g = document.createElement('canvas');
      g.width = w;
      g.height = h;
      var gc = g.getContext('2d');
      var img = gc.createImageData(w, h);
      var d = img.data;

      for (var i = 0; i < d.length; i += 4) {
        var v = (Math.random() * 255) | 0;
        d[i] = d[i + 1] = d[i + 2] = v;
        d[i + 3] = 255;
      }
      gc.putImageData(img, 0, 0);

      ctx.save();
      ctx.globalAlpha = amount;
      ctx.globalCompositeOperation = 'overlay';
      ctx.drawImage(g, 0, 0);
      ctx.restore();
    }

    /* The mark, recoloured by masking: draw it, then fill through its alpha. */
    function paintMark(x, y, size, colour, alpha) {
      if (!markImage || !markImage.complete || !markImage.naturalWidth) return;

      var m = document.createElement('canvas');
      var mw = Math.max(1, Math.round(size));
      var mh = Math.max(1, Math.round(size * (1170 / 980)));
      m.width = mw;
      m.height = mh;

      var mc = m.getContext('2d');
      mc.drawImage(markImage, 0, 0, mw, mh);
      mc.globalCompositeOperation = 'source-in';
      mc.fillStyle = colour;
      mc.fillRect(0, 0, mw, mh);

      ctx.save();
      ctx.globalAlpha = alpha;
      ctx.drawImage(m, x, y, mw, mh);
      ctx.restore();
    }

    /*
     * Sample the artwork's own edge colour, so any letterboxing blends into it
     * instead of showing a hard band.
     */
    function edgeColour(img) {
      var s = document.createElement('canvas');
      s.width = 8;
      s.height = 8;
      var sc = s.getContext('2d', { willReadFrequently: true });
      sc.drawImage(img, 0, 0, 8, 8);

      var d;
      try {
        d = sc.getImageData(0, 0, 8, 8).data;
      } catch (err) {
        return '#4A0E2E';
      }

      var pts = [0, 7, 56, 63]; // the four corner pixels
      var r = 0, g = 0, b = 0;
      for (var i = 0; i < pts.length; i++) {
        var o = pts[i] * 4;
        r += d[o];
        g += d[o + 1];
        b += d[o + 2];
      }
      var n = pts.length;
      return 'rgb(' + Math.round(r / n) + ',' + Math.round(g / n) + ',' + Math.round(b / n) + ')';
    }

    /*
     * Contain, not cover.
     *
     * The artwork carries its own wording, so cropping it would cut the text —
     * on a card narrower than the image, cover-fit slices straight through the
     * middle of the message. Containing shows all of it, and the sampled edge
     * colour fills the remainder so the join is invisible.
     */
    function paintCoverImage(img, w, h) {
      ctx.fillStyle = coverEdge || edgeColour(img);
      coverEdge = ctx.fillStyle;
      ctx.fillRect(0, 0, w, h);

      var scale = Math.min(w / img.naturalWidth, h / img.naturalHeight);
      var dw = img.naturalWidth * scale;
      var dh = img.naturalHeight * scale;
      ctx.drawImage(img, (w - dw) / 2, (h - dh) / 2, dw, dh);
    }

    function paintCover() {
      var w = canvas.width / (window.devicePixelRatio ? Math.min(window.devicePixelRatio, 2) : 1);
      var h = canvas.height / (window.devicePixelRatio ? Math.min(window.devicePixelRatio, 2) : 1);

      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = 1;
      ctx.clearRect(0, 0, w, h);

      // Supplied artwork wins. It is loaded with crossOrigin so the canvas
      // stays readable — a tainted canvas cannot be measured, and measuring is
      // how the auto-reveal knows when half the foil is gone.
      if (coverImage && coverImage.complete && coverImage.naturalWidth) {
        paintCoverImage(coverImage, w, h);
        ctx.globalCompositeOperation = 'destination-out';
        return;
      }

      var styles = window.getComputedStyle(root);
      var hot = opaqueOr(styles.getPropertyValue('--qsw-cover-a'), '#D62246');
      var deep = opaqueOr(styles.getPropertyValue('--qsw-cover-b'), '#4A0E2E');

      // Deep base, then a broad red field lifted off it. Two layers rather
      // than one gradient, so the corners stay dark the way the artwork does.
      ctx.fillStyle = deep;
      ctx.fillRect(0, 0, w, h);

      var field = ctx.createRadialGradient(w * 0.42, h * 0.34, 0, w * 0.42, h * 0.34, w * 0.92);
      field.addColorStop(0, hot);
      field.addColorStop(0.45, 'rgba(190, 30, 62, 0.86)');
      field.addColorStop(1, 'rgba(74, 14, 46, 0)');
      ctx.fillStyle = field;
      ctx.fillRect(0, 0, w, h);

      // Warm bloom behind the top-right mark.
      var glow = ctx.createRadialGradient(w * 0.82, h * 0.14, 0, w * 0.82, h * 0.14, w * 0.7);
      glow.addColorStop(0, 'rgba(244, 118, 158, 0.5)');
      glow.addColorStop(0.55, 'rgba(214, 34, 70, 0.14)');
      glow.addColorStop(1, 'rgba(214, 34, 70, 0)');
      ctx.fillStyle = glow;
      ctx.fillRect(0, 0, w, h);

      // Oversized marks bleeding off opposite corners, as in the artwork.
      paintMark(w * 0.54, -h * 0.30, w * 0.70, '#FF9DB4', 0.26);
      paintMark(-w * 0.34, h * 0.46, w * 0.66, '#FF9DB4', 0.17);

      // Vignette, so the centre reads brighter than the edges.
      var vig = ctx.createRadialGradient(w * 0.5, h * 0.5, w * 0.28, w * 0.5, h * 0.5, w * 0.78);
      vig.addColorStop(0, 'rgba(61, 10, 38, 0)');
      vig.addColorStop(1, 'rgba(45, 6, 28, 0.55)');
      ctx.fillStyle = vig;
      ctx.fillRect(0, 0, w, h);

      paintGrain(Math.round(w), Math.round(h), 0.55);

      var text = (cfg.coverText || 'Scratch Here').toString();
      if (text) {
        ctx.save();
        ctx.fillStyle = '#FFFFFF';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        // Use the theme's own typeface — it is already loaded on the page, so
        // the foil matches the rest of the store rather than falling back to a
        // generic system stack.
        var family =
          styles.fontFamily ||
          'ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif';

        var size = Math.max(18, Math.round(w * 0.135));
        var setFont = function (px) {
          ctx.font = '700 ' + px + 'px ' + family;
        };
        setFont(size);

        // Shrink to fit rather than let a longer label run off the card.
        var maxW = w * 0.82;
        while (ctx.measureText(text).width > maxW && size > 12) {
          size -= 1;
          setFont(size);
        }

        ctx.shadowColor = 'rgba(74, 14, 46, 0.35)';
        ctx.shadowBlur = size * 0.28;
        ctx.fillText(text, w / 2, h / 2);
        ctx.restore();
      }

      ctx.globalCompositeOperation = 'destination-out';
    }

    function size() {
      var rect = card.getBoundingClientRect();
      var w = Math.max(1, Math.round(rect.width));
      var h = Math.max(1, Math.round(rect.height));
      var dpr = Math.min(window.devicePixelRatio || 1, 2);

      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      canvas.style.width = w + 'px';
      canvas.style.height = h + 'px';

      // Work in CSS pixels; the backing store stays at device resolution.
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      paintedWidth = w;
      paintCover();

      // The mark decodes asynchronously; repaint once, unless the customer has
      // already started scratching (repainting would wipe their progress).
      if (!coverImage && cfg.coverImage) {
        coverImage = new Image();
        coverImage.crossOrigin = 'anonymous';
        coverImage.onload = function () {
          if (!started && !revealed) paintCover();
        };
        coverImage.onerror = function () {
          // Fall back to the generated foil rather than showing a blank card.
          coverImage = null;
        };
        coverImage.src = cfg.coverImage;
      }

      if (!markImage) {
        markImage = new Image();
        markImage.onload = function () {
          if (!started && !revealed) paintCover();
        };
        markImage.src = MARK_SRC;
      }
    }

    function pointAt(e) {
      var rect = canvas.getBoundingClientRect();
      return { x: e.clientX - rect.left, y: e.clientY - rect.top };
    }

    function scratchTo(p) {
      var radius = Math.max(18, paintedWidth * 0.075);

      // Under destination-out only the source ALPHA matters, so these must be
      // fully opaque. Explicit, because a merchant can set a foil colour with
      // alpha in the theme editor and that would otherwise erase only partially.
      ctx.fillStyle = '#000000';
      ctx.strokeStyle = '#000000';
      ctx.globalAlpha = 1;

      ctx.lineWidth = radius * 2;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';

      ctx.beginPath();
      if (last) {
        ctx.moveTo(last.x, last.y);
        ctx.lineTo(p.x, p.y);
        ctx.stroke();
      }

      // Arc as well, so a single tap clears something.
      ctx.beginPath();
      ctx.arc(p.x, p.y, radius, 0, Math.PI * 2);
      ctx.fill();

      last = p;
    }

    // Sampled rather than exhaustive — this runs during pointermove.
    function clearedRatio() {
      var w = canvas.width;
      var h = canvas.height;
      if (!w || !h) return 0;

      var data;
      try {
        data = ctx.getImageData(0, 0, w, h).data;
      } catch (err) {
        return 0; // tainted canvas shouldn't happen here, but never throw
      }

      var step = 8;
      var total = 0;
      var clear = 0;

      for (var y = 0; y < h; y += step) {
        for (var x = 0; x < w; x += step) {
          var alpha = data[(y * w + x) * 4 + 3];
          total++;
          if (alpha < 128) clear++;
        }
      }
      return total ? clear / total : 0;
    }

    function maybeAutoReveal() {
      var now = Date.now();
      if (now - lastCheck < 180) return;
      lastCheck = now;
      if (clearedRatio() >= REVEAL_THRESHOLD) reveal();
    }

    function down(e) {
      if (revealed) return;
      drawing = true;
      started = true;
      last = null;

      if (canvas.setPointerCapture && e.pointerId != null) {
        try {
          canvas.setPointerCapture(e.pointerId);
        } catch (err) {
          /* ignore */
        }
      }
      scratchTo(pointAt(e));
      e.preventDefault();
    }

    function move(e) {
      if (!drawing || revealed) return;
      scratchTo(pointAt(e));
      maybeAutoReveal();
      e.preventDefault();
    }

    function up() {
      if (!drawing) return;
      drawing = false;
      last = null;
      if (!revealed && clearedRatio() >= REVEAL_THRESHOLD) reveal();
    }

    function revealNow() {
      // Clear the whole foil instantly, no transition bookkeeping.
      revealed = true;
      drawing = false;
      card.classList.add('is-revealed');
      canvas.setAttribute('aria-hidden', 'true');
      if (hint) hint.hidden = true;
      if (revealBtn) revealBtn.hidden = true;
      setPrizeExposed(true);
    }

    function reveal() {
      if (revealed) return;
      revealNow();

      if (prefersReducedMotion()) {
        canvas.hidden = true;
      } else {
        window.setTimeout(function () {
          canvas.hidden = true;
        }, 500);
      }

      if (typeof handler === 'function') handler();
    }

    /*
     * Put the foil back for the next card. The listeners are attached once and
     * kept, so this cannot pile up handlers however many cards someone holds.
     */
    function restart(next) {
      handler = next;
      revealed = false;
      started = false;
      drawing = false;
      last = null;

      card.classList.remove('is-revealed');
      canvas.hidden = false;
      canvas.removeAttribute('aria-hidden');
      if (hint) hint.hidden = false;
      if (revealBtn) revealBtn.hidden = false;

      // Must run while the card screen is visible, or it measures zero.
      if (ctx) size();
    }

    function wireReveal() {
      if (!revealBtn) return;
      revealBtn.addEventListener('click', function () {
        reveal();
      });
    }

    size();

    canvas.addEventListener('pointerdown', down);
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
    window.addEventListener('pointercancel', up);

    // Mobile browsers fire resize when the URL bar hides. Only repaint if the
    // card actually changed width and the customer hasn't started scratching —
    // repainting mid-scratch would wipe their progress.
    window.addEventListener('resize', function () {
      if (revealed || started) return;
      var w = Math.round(card.getBoundingClientRect().width);
      if (Math.abs(w - paintedWidth) > 2) size();
    });

    wireReveal();

    return { reveal: reveal, revealNow: revealNow, restart: restart };
  }

  // ------------------------------------------------------------------- boot

  lookupAll(tokens)
    .then(function (list) {
      var prizes = [];
      for (var i = 0; i < list.length; i++) {
        if (list[i]) prizes.push(buildPrize(list[i], tokens[i]));
      }

      if (!prizes.length) {
        fail(
          assigned
            ? 'We could not load the prizes on your account. Please contact us and we will sort it out.'
            : 'We could not find this card. Please check the QR code on your card and scan it again.'
        );
        return;
      }

      var total = prizes.length;
      var current = 0;

      var scratch = initScratch(null);
      var progress = $('[data-qsw-progress]');
      var pager = $('[data-qsw-pager]');
      var pagerLabel = $('[data-qsw-pager-label]');
      var prevBtn = $('[data-qsw-prev]');
      var nextBtn = $('[data-qsw-next]');

      initCopy();

      // Scratched state is per token, so it survives across cards and visits.
      function keyFor(i) {
        return STORAGE_PREFIX + prizes[i].token;
      }

      function isDone(i) {
        return storeGet(keyFor(i)) === '1';
      }

      function goCard(i) {
        current = i;
        renderCardTeaser(prizes[i]);
        renderReward(prizes[i]);
        setPrizeExposed(false);

        if (progress) {
          progress.textContent = progressText(i + 1, total);
          setHidden(progress, total < 2);
        }

        show('card');

        // After show(), never before — restart measures the card.
        scratch.restart(function () {
          storeSet(keyFor(i), '1');
          announce('You won ' + prizes[i].label + '.');

          // Let the prize land under the foil for a beat before the panel that
          // carries the code takes over.
          window.setTimeout(
            function () {
              goReward(i);
            },
            prefersReducedMotion() ? 250 : 1100
          );
        });
      }

      function goReward(i) {
        current = i;
        renderReward(prizes[i]);
        setPrizeExposed(true);

        setHidden(pager, total < 2);
        if (pagerLabel) pagerLabel.textContent = progressText(i + 1, total);
        if (prevBtn) prevBtn.disabled = i === 0;
        if (nextBtn) nextBtn.disabled = i >= total - 1;

        show('reward');
      }

      // A card they have not scratched gets its foil; one already done goes
      // straight to the code.
      function goTo(i) {
        if (i < 0 || i >= total) return;
        if (isDone(i)) goReward(i);
        else goCard(i);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(current - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(current + 1);
        });
      }

      // Start on the first card they have not scratched yet. If they are all
      // done this is a re-scan, so show the first prize and let them page.
      var start = 0;
      while (start < total && isDone(start)) start++;
      if (start >= total) goReward(0);
      else goCard(start);
    })
    .catch(function () {
      fail(
        'We could not reach the prize service just now. Please check your connection and scan your card again in a moment.'
      );
    });
})();
